import { UserMessageResponse } from '@/types/service-response'

export class UserMessage {
  private constructor (
    readonly id: number,
    readonly message: string,
    readonly date: string,
    readonly origin: string,
    readonly time: string
  ) {}

  static createListFromResponse (data: UserMessageResponse[]): Array<UserMessage> {
    return data.map((item: UserMessageResponse) => {
      return new UserMessage(
        item.ID ? item.ID : 0,
        item.Message ? item.Message : '',
        item.Datum ? item.Datum : '',
        item.Origin ? item.Origin : '',
        item.Time ? item.Time : ''
      )
    })
  }
}
